// TanStack Query hook for the console Home dashboard (/api/dashboard).

import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { DashboardSummary } from "./types";

export function useDashboard() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: () => apiFetch<DashboardSummary>("/api/dashboard"),
    staleTime: 30_000,
  });
}
